import { useEffect, useRef } from "react";

export const usePreviousValue = (value: unknown) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
